<div  style="display: flex; height: 100%; justify-content: center;">
  <div class="col-md-4 col-md-offset-4">
    <div class="login-panel panel panel-default">
      <div class="panel-heading">
        <h3 class="panel-title">Please Sign In</h3>
      </div>
      <div class="panel-body">


        <p>Please login to see this page.</p>


        <form role="form">
          <fieldset>
            <div class="form-group">
              <input class="form-control" placeholder="Username" [(ngModel)]="username" name="username" type="text" autofocus="">
            </div>
            <div class="form-group">
              <input class="form-control" placeholder="Password" [(ngModel)]="password" name="password" type="password" value="">
            </div>
            <!-- Change this to a button or input when using this as a form -->
            <div style="display: flex;
    justify-content: space-between;
    align-items: center;">
              <input type="submit" value="login" (click)="login()">

              <div>OR</div>

              <a (click)="googleLogin()" style="cursor: pointer; text-decoration: none;">
                <img src="/assets/btn_google_signin_light_normal_web.png"
                     alt="Login with Google">
              </a>
            </div>
            <div class="alert-danger">{{errorMsg}}</div>
          </fieldset>
        </form>

        <!--<p><a href="/accounts/password_reset/">Lost password?</a></p>-->
      </div>
    </div>
  </div>
</div>
